import { LoadingStates } from '@pb/utils'

import { AdyenState } from '../types'

export const initialState: AdyenState = {
  config: null,
  actionObject: null,
  initStatus: LoadingStates.NotLoaded,
}
